import { BreakpointProperties } from './types'
import { CustomCSSProperties } from '../../types'
import { breakpointsArray } from 'src/styles/js/breakpoints'

const applyBreakpointStyles = (
  property: BreakpointProperties,
  stylePrefix: string,
): CustomCSSProperties => {
  // creates an empty object to store the CSS variables
  const breakpointValues: Record<string, number | string> = {}

  // Apply values based on property type
  breakpointsArray.forEach((bp, index) => {
    if (typeof property === 'object' && property !== null) {
      if (property[bp] !== undefined) {
        breakpointValues[bp] = property[bp]
      } else if (index > 0) {
        // Inherit previous value if nothing specified - this fills the gaps between omitted responsive values in the object
        const prevBp = breakpointsArray[index - 1]
        breakpointValues[bp] = breakpointValues[prevBp]
      }
    } else {
      // else if the property is a string or number, pass it directly
      breakpointValues[bp] = property
    }
  })

  // Convert to CSS variables, applying specific logic for some properties
  const customStyles: CustomCSSProperties = {}
  Object.keys(breakpointValues).forEach((bp) => {
    const value = breakpointValues[bp]
    if (stylePrefix === 'container-maxWidth') {
      customStyles[`--${stylePrefix}-${bp}`] = `${value}px`
    } else if (
      ['container-yAlign', 'container-xAlign', 'container-spacing'].includes(stylePrefix)
    ) {
      // Check for special keywords
      if (['between', 'around', 'evenly'].includes(value.toString())) {
        customStyles[`--${stylePrefix}-${bp}`] = `space-${value}`
      } else {
        customStyles[`--${stylePrefix}-${bp}`] = `${value}`
      }
    } else {
      customStyles[`--${stylePrefix}-${bp}`] = value
    }
  })

  return customStyles
}

export default applyBreakpointStyles
